import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { environment } from 'src/environments/environment';
import { StorageHelperService } from '../storageHelper/storage-helper.service';
import { apiConfig } from '../../apiConfig/apiConfig';
import { CoreHttpService } from '../../httpServices/core-http.service';


@Injectable({
  providedIn: "root",
})
export class PublicService {
  constructor(
    private http: HttpClient,
    private storageHelperService: StorageHelperService,
    private coreHttpService: CoreHttpService
  ) {}

  async stringConversion(string) {
    var splitStr = string.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }

  isDrmEnabled(video) {
    if (video && video.drmEnabled) {
      return true;
    }
    return false;
  }

  async getCloudFrontUrl(bucketUrl) {
    return (
      environment.cloudFrontUrl +
      bucketUrl[bucketUrl.length - 3] +
      "/" +
      bucketUrl[bucketUrl.length - 2] +
      "/" +
      bucketUrl[bucketUrl.length - 1]
    );
  }

  async dataUploadedTime(timestamp) {
    var difference = new Date().getTime() - new Date(timestamp).getTime();
    var ms = difference % 1000;
    difference = (difference - ms) / 1000;
    var secs = difference % 60;
    difference = (difference - secs) / 60;
    var mins = difference % 60;
    var hrs = (difference - mins) / 60;
    if (hrs > 0 && hrs <= 24) {
      return hrs + " hours ago";
    } else if (mins > 0 && hrs == 0) {
      return mins + " minutes ago";
    } else if (secs > 0 && mins == 0 && hrs == 0) {
      return secs + " Seconds ago";
    } else {
      var date = new Date(timestamp),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return day + "-" + mnth + "-" + date.getFullYear();
    }
  }

  async liveClassAudit(entityId, entityType, entityName, requestType, token) {
    let studentDetails = JSON.parse(
      this.storageHelperService.getDecryptData("studentProfile")
    );
    let body = {
      entityId: entityId,
      entityType: entityType,
      entityName: entityName,
      collegeId: studentDetails["collegeId"],
      requestType: requestType,
    };
    return this.coreHttpService.postSecuredWithHeaders(
      environment.baseUrl + apiConfig.publicApiUrls.audit,
      body,
      {}
    );
  }

  async addAudit(entityId, entityType, entityName, requestType,userName) {
    let studentDetails = JSON.parse(
      this.storageHelperService.getDecryptData("studentProfile")
    );
    let body = {
      entityId: entityId,
      entityType: entityType,
      entityName: entityName,
      collegeId: studentDetails["collegeId"],
      requestType: requestType,
      userName:userName
    };

    this.coreHttpService
      .postSecuredWithHeaders(
        environment.baseUrl + apiConfig.publicApiUrls.audit,
        body,
        {}
      )
      .subscribe(
        (response) => {
        },
        async (error) => {
          console.log("audit error is" + JSON.stringify(error));
        }
      );
  }
}
